import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import MicOutlinedIcon from '@material-ui/icons/Mic';
import MicOffOutlinedIcon from '@material-ui/icons/MicOff';
import VideocamOutlinedIcon from '@material-ui/icons/Videocam';
import VideocamOffOutlinedIcon from '@material-ui/icons/VideocamOffOutlined';
import clsx from 'clsx';
import VideoStatus from 'enums/VideoStatus';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMutedAction, toggleVideoAction } from 'store/video/videoActions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  avatar: {
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(3),
    marginRight: theme.spacing(3),
    color: 'white',
    fontWeight: '600',
  },
  blue: {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
  },
  unChecked: {
    background: 'rgba(0,0,0,.5)',
  },
}));

export default function LocalVideoTileControls() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { videoStatus, muted, name, audioVideo } = useSelector(({ video, chime }) => ({
    videoStatus: video.videoStatus,
    muted: video.muted,
    name: chime.name,
    audioVideo: chime.audioVideo,
  }));
  const toggleMute = async () => {
    if (muted) {
      audioVideo.realtimeUnmuteLocalAudio();
    } else {
      audioVideo.realtimeMuteLocalAudio();
    }
    dispatch(setMutedAction(audioVideo.realtimeIsLocalAudioMuted()));
  };

  const avatarMicStyle = clsx({
    [classes.blue]: !muted,
    [classes.avatar]: true,
    [classes.unChecked]: muted,
  });

  const avatarVideoStyle = clsx({
    [classes.blue]: videoStatus === VideoStatus.Enabled,
    [classes.avatar]: true,
    [classes.unChecked]: videoStatus !== VideoStatus.Enabled,
  });

  return (
    <div className={classes.root}>
      <Avatar
        className={avatarVideoStyle}
        onClick={() => dispatch(toggleVideoAction())}
        role="button"
      >
        {videoStatus === VideoStatus.Enabled ? (
          <VideocamOutlinedIcon
            data-testid="video-on-icon"
            titleAccess="toggle video off"
            fontSize="small"
          />
        ) : (
          <VideocamOffOutlinedIcon
            data-testid="video-off-icon"
            titleAccess="toggle video on"
            fontSize="small"
          />
        )}
      </Avatar>
      <Avatar className={avatarMicStyle} onClick={toggleMute}>
        {muted ? (
          <MicOffOutlinedIcon data-testid="mic-off-icon" fontSize="small" />
        ) : (
          <MicOutlinedIcon data-testid="mic-on-icon" fontSize="small" />
        )}
      </Avatar>
      <Box flexGrow={1} />
      <Chip className={classes.chip} label={name} />
    </div>
  );
}
